import { render } from "./cdrBatchPremium.vue?vue&type=template&id=8d6fb5da&scoped=true"
import script from "./cdrBatchPremium.vue?vue&type=script&lang=js"
export * from "./cdrBatchPremium.vue?vue&type=script&lang=js"

import "./cdrBatchPremium.vue?vue&type=style&index=0&id=8d6fb5da&scoped=true&lang=css"
import "./cdrBatchPremium.vue?vue&type=style&index=1&id=8d6fb5da&lang=css"
script.render = render
script.__scopeId = "data-v-8d6fb5da"

export default script